import React from 'react'
import { graphql } from 'gatsby'
import { PrismicRichText} from '@prismicio/react'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import OtherOptionsMenu from '@components/OtherOptionsMenu'
import FeaturedItems from './FeaturedItems'
import ContentGrid from '@components/ContentGrid'
import './ContentPageStyles.css'

export const query = graphql`
query SubjectQuery($uid: String){  
    allPrismicSubject(filter: { uid: { eq: $uid }}){
        edges {
            node {
                id 
                uid
               url
                data {
                    subject_name
                    subject_description_long {
                        text
                        html
                        raw
                    }
                    subject_blurb
                    subject_icon
                }
            }
        }            
    }         
}`

const SubjectFeaturedItems = ({ featuredItems }) => {
    if(featuredItems === null || featuredItems.length === 0) return null
     return (
        <FeaturedItems featuredItems={featuredItems}/>
     )
  }

  const SubjectDescription = ({ subjectDescription }) => {
    if(subjectDescription === null || subjectDescription.length === 0) return null
     return (
        <PrismicRichText field={subjectDescription}/> 
     )
  }

const Subject = (props) => {
    const subject = props.data.allPrismicSubject.edges[0].node;
    const iconClassName = subject.data.subject_icon ? subject.data.subject_icon + ' page-icon align-middle' : "";
    const documents = props.pageContext.documents;

    const featuredDocs = documents.filter(doc => doc.data.featured === "Yes" && doc.data.featured_page === subject.data.subject_name).slice(0, 3);

    if(!subject) return null;

    if (typeof window !== "undefined"){
        return(
            <Layout>
            <SEO title={subject.data.subject_name ? subject.data.subject_name : "Unknown subject"} description={subject.data.subject_blurb} pathname={props.location.pathname}/>
            <Row>
                <Col md={3} lg={2} className="text-center">
                    <span className="icon-container h-100">
                        <i className={iconClassName} aria-hidden="true"/>
                    </span>
                </Col>
                <Col md={9} lg={7} className="text-left">
                    <h1>{subject.data.subject_name ? subject.data.subject_name : ""}</h1> 
                    <div>
                    <SubjectDescription subjectDescription={subject.data.subject_description_long.raw}/>
                    </div>
                </Col>
                <Col md={12} lg={3} className="pr-3 text-lg-right">
                    <OtherOptionsMenu isAllContent={false}/>
                </Col>
             </Row>
             <hr className="my-4"/>    
             <SubjectFeaturedItems featuredItems={featuredDocs}/>
             <Row>
                 <Col>
                 <hr className="my-4"/>
                 <h2 className="text-left mb-3">All {subject.data.subject_name} Content</h2>
                    <ContentGrid documents={documents}/>
                </Col>
             </Row>
        </Layout>
        )
    }
    else {
        return null;
    }
}

export default Subject;